/**
 * Suspense fallback for the routed content area only (PLAN.md item 4).
 *
 * Wraps just `<Outlet/>` inside each layout shell — NOT the whole
 * `<Routes>` tree — so a lazy page chunk loading on navigation shows this
 * thin bar in place of the page content while sidebar/header/footer stay
 * mounted, instead of unmounting the entire layout and flashing a blank
 * screen.
 */
export function RouteLoader(): JSX.Element {
  return (
    <div className="space-y-1.5" aria-hidden>
      <div className="h-1 w-full overflow-hidden rounded-full bg-primary/10">
        <div className="h-full w-1/3 animate-progress-slide rounded-full bg-primary/70" />
      </div>
    </div>
  );
}
